var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"36px"}},[_c('v-alert',{staticStyle:{"height":"auto"},attrs:{"dense":"","type":"error"}},[_vm._v(" Не удалось получить доступ к GitLab :( ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }